import { render, staticRenderFns } from "./PointSummary.vue?vue&type=template&id=0f76b894&scoped=true&"
import script from "./PointSummary.vue?vue&type=script&lang=js&"
export * from "./PointSummary.vue?vue&type=script&lang=js&"
import style0 from "./PointSummary.vue?vue&type=style&index=0&id=0f76b894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76b894",
  null
  
)

export default component.exports